import { ActionContext, ActionTree } from "vuex";
import { GetterTree } from "vuex";
import { AssignmentWork } from "@/model/AssignmentWork";


const actions: ActionTree<AssignmentWork, any> = {
  setState(
    { commit }: ActionContext<AssignmentWork, any>,
    payload: AssignmentWork
  ): void {
    commit("setState", payload);
  },
  clearState({ commit }: ActionContext<AssignmentWork, any>): void {
    commit("clearState");
  }
};

const mutations = {
  setState(state: AssignmentWork, payload: AssignmentWork) {
    Object.assign(state, payload);
  },
  clearState(state: AssignmentWork) {
    Object.assign(state, {});
  }
};

const getters: GetterTree<AssignmentWork, any> = {
  currentState(state: AssignmentWork): any {
    return state;
  }
};

const namespaced: boolean = true;
export default {
  namespaced,
  state: {},
  getters,
  actions,
  mutations
};
